<template>
    <div>
        <!-- alert de mensaje tipo aeropuerto -->
        <v-row>
            <v-alert
            :value="alert"
            color="orange darken-4"
            dark
            border="top"
            icon="mdi-home"
            transition="scale-transition"
            width="100%"
            >
            <h1 class="parpadea" id="movetxt">{{texto}}</h1>
            </v-alert>
        </v-row>
        <!-- alert de mensaje tipo aeropuerto -->

        <v-container>
            <v-card class="d-inline-block mx-auto" width="100%" color="grey lighten-3">
                <v-card-text>
                    <v-row>
                        <v-col>
                            <h1>TICKET: {{ultimo_ticket.CODIGO_TICKET}}</h1>
                            <!-- <v-divider color="white"></v-divider> -->
                        </v-col>
                        <v-col>
                            <h1>FECHA LLEGADA: {{ultimo_ticket.FECHA_HORA_ACOPLADO|formatearFecha}}</h1>

                        </v-col>
                        <v-col>
                            <h1>HORA LLEGADA: {{ultimo_ticket.FECHA_HORA_ACOPLADO|formatearHora}}</h1>

                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-text>
                    <div class="container-table">
                        <table class="table-dashboard">
                            <thead>
                                <th class="cabecera-guias border">N° GUÍA</th>
                                <th class="cabecera-guias border">PROVEEDOR</th>
                                <th class="cabecera-guias border">FECHA</th>
                                <th class="cabecera-guias border">HORA</th>
                                <th class="cabecera-guias border">MATERIA PRIMA</th>
                                <th class="cabecera-guias border">RESTRICCIÓN</th>
                            </thead>
                            <tbody>
                                <tr v-for="guia in ultimas_guias" :key="guia.CODIGO_GUIA" class="fuente-tabla-guias"
                                            v-bind:class="[{'parpadea':guia.RESTRICCION != null,'con_restriccion':guia.RESTRICCION != null}]">
                                    <td class="border">{{guia.CODIGO_GUIA}}</td>
                                    <td class="border">{{guia.PROVEEDOR}}</td>
                                    <td class="border">{{guia.FECHA_GUIA}}</td>
                                    <td class="border">{{guia.HORA_GUIA}}</td>
                                    <td class="border">{{guia.MATERIA_PRIMA}}</td>
                                    <td class="border">{{guia.RESTRICCION}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </v-card-text>
            </v-card>
        </v-container>
        
    </div>
</template>
<script>
export default {
    data:()=>({
        ultimo_ticket:{},
        ultimas_guias:[],
        alert:true,
        mensaje_alert:false,
        texto:''
    }),
    beforeDestroy() {
        this.socket.off('nuevo-ticket');
        this.socket.disconnect();
    },
    mounted() {
        this.socket.connect();
        this.socket.on('nuevo-ticket',(data)=>{
            console.log("informacion recibida del socket",data);
            this.ultimo_ticket = data.ticket;
            this.ultimas_guias = data.guias;
            this.texto = `NUEVO TICKET INGRESADO - ${this.ultimo_ticket.CODIGO_TICKET}`
            this.mensaje_alert = true;
            this.ocultarAlert();
        })
    },
    methods: {
        ocultarAlert(){
            setTimeout(()=>{ this.mensaje_alert = false; }, 60000);
        }
    },
}
</script>
<style scoped>
.title{
    margin: 0 auto;
}
.fuente-grande{
    font-size: 80px;
}
.fuente-mediana{
    font-size: 50px;
    font-weight:900;
}
.fuente-tabla-guias{
    font-size:18px;
}
.sin_restriccion{
    background-color: #ffff;
    color:#000000;
}
.con_restriccion{
    background-color: #B71C1C;
    color: #ffffff;
}
.center{
    text-align: center;
}
.rojo{
    color: #E53935;
}
.table-dashboard {
  border-collapse: collapse;
  width: 100%;
}

.border{
  border: 1px solid #000;
}

.cabecera{
    padding: 1em;
    background-color: #FFC107;
}

.cabecera-guias{
    padding: 1em;
    background-color: #004D40;
    color:#ffffff;
}

table tbody tr td{
    text-align: center;
    padding: 0.5em;
}

.container-table{
    overflow-x: auto;
}
/*animacion de parpadeo */
.parpadea {
  
  animation-name: parpadeo;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;

  -webkit-animation-name:parpadeo;
  -webkit-animation-duration: 1.5s;
  -webkit-animation-timing-function: linear;
  -webkit-animation-iteration-count: infinite;
}

@-moz-keyframes parpadeo{  
  0% { opacity: 1.0; }
  25% {opacity: 0.75}
  50% { opacity: 0.50; }
  75% {opacity: 0.75}
  100% { opacity: 1.0; }
}

@-webkit-keyframes parpadeo {  
  0% { opacity: 1.0; }
  25% {opacity: 0.75}
  50% { opacity: 0.50; }
  75% {opacity: 0.75}
  100% { opacity: 1.0; }
}

@keyframes parpadeo {  
  0% { opacity: 1.0; }
  25% {opacity: 0.75}
  50% { opacity: 0.50; }
  75% {opacity: 0.75}
  100% { opacity: 1.0; }
}
/*animacion de parpadeo */

/**animacion de desplazamiento de texto */
#movetxt {
    -webkit-animation: moving 15s infinite;
    animation: moving 15s infinite;
}
		
@-webkit-keyframes moving {
    from {-webkit-transform: translateX(0%);}
    to {-webkit-transform: translateX(100%);}
}

@keyframes moving {
    from {transform: translateX(0%);}
    to {transform: translateX(100%);}
}
/**animacion de desplazamiento de texto */

</style>